import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { StorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GuaranteeService {

  constructor(public storage: StorageService, public httpClient: HttpClient) {
 
  }
  getGuarantee(filters) {
    var promise = new Promise<any>((resolve, reject) => {

      this.httpClient.get(environment.apiUrl + "/guarantee", { params: filters }).subscribe((data: any) => {
        resolve(data)
      }, err => reject(err)
      );
    })
    return promise
  }
}
